import { createContext, ReactNode, useContext } from "react";

import { useFilterQuoteActivity } from "./filter-quote-activity.hook";

const FilterQuoteActivityContext = createContext(
  {} as ReturnType<typeof useFilterQuoteActivity>
);
export function useFilterQuoteActivityContext() {
  return useContext(FilterQuoteActivityContext);
}

interface FilterQuoteActivityProviderProps {
  children: ReactNode;
}
export function FilterQuoteActivityProvider({
  children,
}: FilterQuoteActivityProviderProps) {
  return (
    <FilterQuoteActivityContext.Provider value={useFilterQuoteActivity()}>
      {children}
    </FilterQuoteActivityContext.Provider>
  );
}